import { FeatherIcon } from './FeatherIcon';

/**
 * author: Simran
 * id A0C975EA-A25D-4882-96DE-39CB72DAC2CA
 * name feather
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/feather.svg
 * tags
 * - Nature 
 */
export const QuillIcon = FeatherIcon;
export default QuillIcon